import { RecruitmentSearchInput } from 'client/generated';

type Props = Required<Omit<RecruitmentSearchInput, 'pagingCursor'>>;

// GraphQL の SearchRecruitment Query の inputから 募集検索のURLのクエリパラメータを生成する
export const useUrlQueryParams = ({
  date,
  areaIds,
  licenseIds,
  facilityFeatureIds,
  jobBenefitIds,
  sortOptionId,
  minimumDailyWage,
  maximumDailyWage,
  workingHourOptionIds,
  maximumWorkingHours,
  jobTaskIds,
  onlyRecruiting,
}: Props) => {
  const createUrlQuery = () => {
    const query: { [key: string]: string | string[] | undefined } = {};

    if (date) {
      query.date = date;
    }
    if (areaIds) {
      query.area_ids = areaIds;
    }
    if (licenseIds) {
      query.license_ids = licenseIds;
    }
    if (facilityFeatureIds) {
      query.facility_feature_ids = facilityFeatureIds;
    }
    if (jobBenefitIds) {
      query.job_benefit_ids = jobBenefitIds;
    }
    if (workingHourOptionIds) {
      query.working_hour_option_ids = workingHourOptionIds;
    }
    if (sortOptionId) {
      query.sort_option_id = sortOptionId;
    }
    if (typeof maximumWorkingHours === 'number') {
      query.maximum_working_hours = maximumWorkingHours + '';
    }
    if (minimumDailyWage) {
      query.minimum_daily_wage = minimumDailyWage.toString();
    }
    if (maximumDailyWage) {
      query.maximum_daily_wage = maximumDailyWage.toString();
    }
    if (jobTaskIds) {
      query.job_task_ids = jobTaskIds;
    }
    if (onlyRecruiting) {
      query.only_recruiting = 'true';
    }

    return query;
  };

  return { urlQueryParams: createUrlQuery() };
};
